import axios from "axios";
import { Config } from "../Config";
import PAPI from "./patientsInstance";
import { userAccessToken } from "../helpers";

export const fetchCareGapsPatients = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    first_name,
    last_name,
    dob,
    sex,
    mobile_phone,
    start_age,
    end_age,
    insurance_ids,
    last_visit,
    visit_day_query_type,
    visited_last_days,
    not_visited_last_days,
    quality_measure,
    order_by,
    city,
    state,
    zip,
  } = filter;


  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";

    let startAge = start_age ? `&start_age=${start_age}` : "";
    let endAge = end_age ? `&end_age=${end_age}` : "";
    let insuranceIds = "";
    if (insurance_ids.length > 0) {
      insuranceIds = insurance_ids.map((id) => `&insurance_ids=${id}`).join("");
    }

    // const insuranceIds = insurance_ids ? `&insurance_ids=${insurance_ids}` : "";
    let visitedLastDays = visited_last_days
      ? `&visited_last_days=${visited_last_days}`
      : "";
    let notVisitedLastDays = not_visited_last_days
      ? `&not_visited_last_days=${not_visited_last_days}`
      : "";
    let visitDayQueryType = visited_last_days || not_visited_last_days ? `&visit_day_query_type=${visit_day_query_type}` : ``;

    let qualityMeasure = quality_measure
      ? `&quality_measure=${JSON.stringify(quality_measure)}`
      : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    let sCity = city ? `&city=${city}` : "";
    let sState = state ? `&state=${state}` : "";
    let sZip = zip ? `&zip=${zip}` : "";

    return PAPI.get(
      `/patients/get-patients-with-care-gaps?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}&first_name=${first_name}&last_name=${last_name}&dob=${dob}&sex=${sex}&mobile_phone=${mobile_phone}${startAge}${endAge}${insuranceIds}&last_visit=${last_visit}${sCity}${sState}${sZip}${visitDayQueryType}${visitedLastDays}${notVisitedLastDays}${searchParam}${qualityMeasure}${orderBy}`,
      {}
    );
  } catch (error) {}
};

export const getPatientByPratice = (props) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    risk_level,
    preventative_due,
    have_not_visited_in_days,
  } = props;

  const searchParam = search_term ? `&search_term=${search_term}` : "";
  const riskLevelParam = risk_level ? `&risk_level=${risk_level}` : "";
  const preventativeDueParam = preventative_due
    ? `&preventative_due=${preventative_due}`
    : "";
  const notVisitedInDaysParam = have_not_visited_in_days
    ? `&visit_day_query_type=2&not_visited_last_days=${have_not_visited_in_days}`
    : ""; 

  return PAPI.get(
    `/patients/get-patients-by-practice?account_id=${account_id}&location_id=${location_id}&page=${page}&per_page=${per_page}${searchParam}${riskLevelParam}${preventativeDueParam}${notVisitedInDaysParam}`,
    {}
  );
};

export const getMeasures = async() => {
  try {
    const response = await axios.get(
      `${Config.apiServerUrl}/care-gaps/all`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};

export const exportCareGapsPatients = async (filter) => {
  const {
    account_id,
    location_id,
    page,
    per_page,
    search_term,
    first_name,
    last_name,
    dob,
    sex,
    mobile_phone,
    start_age,
    end_age,
    insurance_ids,
    last_visit,
    visit_day_query_type,
    visited_last_days,
    not_visited_last_days,
    quality_measure,
    order_by,
    city,
    state,
    zip,
  } = filter;


  try {
    let searchParam = search_term ? `&search_term=${search_term}` : "";

    let startAge = start_age ? `&start_age=${start_age}` : "";
    let endAge = end_age ? `&end_age=${end_age}` : "";
    let insuranceIds = "";
    if (insurance_ids.length > 0) {
      insuranceIds = insurance_ids.map((id) => `&insurance_ids=${id}`).join("");
    }

    let visitedLastDays = visited_last_days ? `&visited_last_days=${visited_last_days}` : "";
    let notVisitedLastDays = not_visited_last_days ? `&not_visited_last_days=${not_visited_last_days}` : "";
    let visitDayQueryType = visited_last_days || not_visited_last_days ? `&visit_day_query_type=${visit_day_query_type}` : ``;

    let qualityMeasure = quality_measure ? `&quality_measure=${JSON.stringify(quality_measure)}` : "";
    let orderBy = order_by ? `&order_by=${JSON.stringify(order_by)}` : "";
    let sCity = city ? `&city=${city}` : "";
    let sState = state ? `&state=${state}` : "";
    let sZip = zip ? `&zip=${zip}` : "";

    return PAPI.get(
      `/patients/export-patients-by-practice?account_id=${account_id}&location_id=${location_id}&page=1&per_page=${per_page}&first_name=${first_name}&last_name=${last_name}&dob=${dob}&sex=${sex}&mobile_phone=${mobile_phone}${startAge}${endAge}${insuranceIds}&last_visit=${last_visit}${sCity}${sState}${sZip}${visitDayQueryType}${visitedLastDays}${notVisitedLastDays}${searchParam}${qualityMeasure}${orderBy}`,
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
  } catch (error) {}
};

export const getCareGapHistory = async(account_id, location_id, patient_id, age, gender) => {
  try {
    const response = await axios.post(
      `${Config.apiServerUrl}/care-gaps/patient-care-gaps-history`, {
        account_id: account_id,
        location_id: location_id,
        patient_id: patient_id,
        patient_age: age,
        patient_sex: gender
      },
      {
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: `Bearer ${userAccessToken()}`,
        },
      }
    );
    return response;
  } catch (error) {}
};